
import { Route, Switch, RouteComponentProps } from 'react-router-dom'
import { withProps } from 'src/utils/withProps';
import {Android} from './Android'
import {Ios} from './Ios'

type TParams = { id: string };

export function NetworkEditor(props: RouteComponentProps<TParams>) {
    return (
        <div>
            <Switch>
                <Route path={[
                    '/network_editor/android/copy/:id', 
                ]} component={withProps(Android, { action: 'copy', ...props })}  />

                <Route path={[
                    '/network_editor/android/:id', 
                    '/network_editor/android/'
                ]} component={withProps(Android, { ...props })}  />

                <Route path={[
                    '/network_editor/ios/copy/:id',
                ]} component={withProps(Ios, { action: 'copy', ...props })}  />

                <Route path={[
                    '/network_editor/ios/:id',
                    '/network_editor/ios',
                ]} component={withProps(Ios, { ...props })}  />
            </Switch>
        </div>
    );
}       